import Vue from 'vue';
import { AxiosPromise } from 'axios';
import {
  DataTableResponse,
  Response,
  TireBrand,
} from '@/models';

class TireBrandService extends Vue {
  private ROOT_API = process.env.VUE_APP_ROOT_API + '/webapi/tire-brand';

  public getAll(): AxiosPromise<DataTableResponse<TireBrand>> {
    return Vue.axios.get<DataTableResponse<TireBrand>>(this.ROOT_API);
  }

  public get(id: string): AxiosPromise<Response<TireBrand>> {
    return Vue.axios.get<Response<TireBrand>>(this.ROOT_API + '/' + id);
  }

  public findByName(name: string): AxiosPromise<Response<TireBrand>> {
    return Vue.axios.get<Response<TireBrand>>(this.ROOT_API + '/find-by-name', { params: { name: name } });
  }

}
export const tireBrandService = new TireBrandService();
